
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import ProspectForm from '@/components/forms/ProspectForm.vue'
import GroupManager from '@/components/common/GroupManager.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')

@Component({
  components: {
    BaseCardContainer,
    ProspectForm,
    GroupManager
  }
})
export default class ProspectFiche extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('updateProspectAction') updateProspect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @prospectModule.Action('syncProspectGroupAction') syncProspectGroup: any

  mounted() {
    window.scrollTo(0, 0)
  }

  onSubmit(data: any) {
    this.updateProspect({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      Vue.notify({
        group: 'user',
        type: 'success',
        title: 'Confirmation',
        text: 'Les données ont bien été mises à jour'
      })
      this.$nextTick(() => VueScrollTo.scrollTo('#app'))
    })
  }

  onCancel() {
    this.$router.go(-1)
  }

  async onSync(ids) {
    const id = this.$route.params.id
    await this.syncProspectGroup({
      id,
      formParams: {
        IDS_GROUPE: ids
      }
    })
    if (this.$route.params.id === id) await this.getProspectById(id)
  }
}
